import { THIS_PAGE_IS_BLOCKED, DONT_HAVE_PERMISION } from "../../utils/i18n";
import "./App.css";
import { LogoZendai } from "@ez/design-system";

function App() {
  return (
    <div className="app-container">
      <div className="logo">
        <LogoZendai />
      </div>

      <div className="text-container">
        <h1 className="title">{THIS_PAGE_IS_BLOCKED}</h1>
        <h2 className="description">{DONT_HAVE_PERMISION}</h2>
      </div>
    </div>
  );
}

export default App;
